(function () {
  function initCollabSlideshow(root) {
    var slides = root.querySelectorAll('[data-collab-slide]');
    var dots = root.querySelectorAll('[data-collab-dot]');
    var prevBtn = root.querySelector('[data-collab-prev]');
    var nextBtn = root.querySelector('[data-collab-next]');
    var current = 0;
    var timer = null;

    if (slides.length <= 1) return;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      var enabled = root.getAttribute('data-autoplay') === 'true';
      var speed = parseFloat(root.getAttribute('data-autoplay-speed')) || 5;
      if (!enabled) return;
      stopAutoplay();
      timer = setInterval(next, speed * 1000);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-collab-slideshow]').forEach(initCollabSlideshow);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-collab-slideshow]');
    if (root) initCollabSlideshow(root);
  });
})();
